"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WAITLIST_PRODUCT_TYPES = exports.ALL_RESOURCES_VALUE = void 0;
const enums_service_1 = require("../../services/enums.service");
exports.ALL_RESOURCES_VALUE = 'all';
exports.WAITLIST_PRODUCT_TYPES = [
    enums_service_1.ProductTypesEnum.REGISTRATION,
    enums_service_1.ProductTypesEnum.FOLDERED_REGISTRATION,
];
//# sourceMappingURL=waitlist.consts.js.map